<div class="list">
	@if (workplacesAreEmpty()) {
		<lvr-workplace-accordion [user]="user()" [institutionName]="institutionName()"></lvr-workplace-accordion>
	} @else {
		@for (workplace of visibleWorkplaces(); track workplace.id) {
			<a class="link" [routerLink]="[workplace.id]">
				<lvr-workplace-accordion [workplace]="workplace" [user]="user()"> </lvr-workplace-accordion>
			</a>
		}
		<lvr-paginator
			[length]="totalItems()"
			[pageSize]="pageSize()"
			[pageIndex]="pageIndex()"
			[showFirstLastButtons]="showFirstLastButtons"
			[hidePageSize]="hidePageSize"
			preferenceKey="workplace-list"
			(page)="handlePageEvent($event)"
		>
		</lvr-paginator>
	}
</div>
